module.exports = __webpack_public_path__ + "a76fdb9d62c52d0d2cda4912de25448a.svg";